<template>
<div id='nav-bar'>
    <ul class="nav-panel">
        <li class="nav-item" data-index='1' v-bind:class="{ 'nav-select': isActive}"></li>
        <li class="nav-item" data-index='2' v-bind:class="{ 'nav-select': isActive}"></li>
        <li class="nav-item" data-index='3' v-bind:class="{ 'nav-select': isActive}"></li>
        <li class="nav-item" data-index='4' v-bind:class="{ 'nav-select': isActive}"></li>
    </ul>
</div>
</template>
<script type="text/javascript">

export default {
    name: 'nav-bar',
    data() {
        return {
            
        }
    },
    props: [
        'videoConfig'
    ],
    created: function() {
        var _this = this;

    }
}
</script>
<style rel="stylesheet/scss" lang="scss">
@import "../assets/sass/cmn.scss";
.nav-panel{
   // margin-top: -85px;
    font-size: 0;
    text-align: center;
    .nav-item{
        display: inline-block;
        // width: 247px;
        // height: 90px;
    }
    .nav-item[data-index="1"] {
        background-image: url(componentsImgPath('nav/nav1.png'));
    }
    .nav-item[data-index="2"] {
        background-image: url(componentsImgPath('nav/nav2.png'));
    }
    .nav-item[data-index="3"] {
        background-image: url(componentsImgPath('nav/nav3.png'));
    }
    .nav-item[data-index="4"] {
        background-image: url(componentsImgPath('nav/nav4.png'));
    }
    .nav-select[data-index="1"] {
        background-image: url(componentsImgPath('nav/nav-select1.png'));
    }
    .nav-select[data-index="2"] {
        background-image: url(componentsImgPath('nav/nav-select2.png'));
    }
    .nav-select[data-index="3"] {
        background-image: url(componentsImgPath('nav/nav-select3.png'));
    }
    .nav-select[data-index="4"] {
        background-image: url(componentsImgPath('nav/nav-select4.png'));
    }
}
</style>


// WEBPACK FOOTER //
// src/components/nav-bar.vue